export class PetAssociateModel {
    pet_no: number
    last_name: string
    first_name: string
    middle_initial: string
    associate_no: number
    authority_id: number
    authority_desc: string
    associate_ownership: number

    constructor(
        pet_no: number,
        last_name: string,
        first_name: string,
        middle_initial: string,
        associate_no: number,
        authority_id: number,
        authority_desc: string,
        associate_ownership: number
    ) {
        this.pet_no = pet_no
        this.last_name = last_name
        this.first_name = first_name
        this.middle_initial = middle_initial
        this.associate_no = associate_no
        this.authority_id = authority_id
        this.authority_desc = authority_desc
        this.associate_ownership = associate_ownership
    }
}